import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-section">
            <div className="footer-brand">
              <span className="brand-icon">🏺</span>
              <span className="brand-text">Kumbhar Samaj Onnati Mandal</span>
            </div>
            <p className="footer-description">
              Building a brighter tomorrow for every Kumbhar family through unity, progress, and cultural preservation.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/matrimony">Matrimony</Link></li>
              <li><Link to="/news">News & Updates</Link></li>
              <li><Link to="/matrimony/create">Create Profile</Link></li>
            </ul>
          </div>

          {/* Community */}
          <div className="footer-section">
            <h4 className="footer-heading">Community</h4>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h4 className="footer-heading">Get in Touch</h4>
            <ul className="footer-contact">
              <li>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                Kasba Peth, Pune, Maharashtra
              </li>
              <li>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                kumbharsamajonnatimandal13@gmail.com
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Kumbhar Samaj Onnati Mandal. All rights reserved.</p>
          <div className="footer-legal">
            {/* <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link> */}
          </div>
        </div>
      </div>

      <style jsx>{`
        .footer {
          background: var(--neutral-900);
          color: var(--neutral-300);
          padding: var(--space-16) 0 var(--space-8);
          margin-top: var(--space-24);
        }

        .footer-content {
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1.5fr;
          gap: var(--space-12);
          margin-bottom: var(--space-12);
        }

        .footer-section {
          display: flex;
          flex-direction: column;
          gap: var(--space-4);
        }

        .footer-brand {
          display: flex;
          align-items: center;
          gap: var(--space-2);
          font-family: var(--font-display);
          font-size: var(--text-xl);
          font-weight: var(--weight-bold);
          color: white;
          margin-bottom: var(--space-2);
        }

        .brand-icon {
          font-size: var(--text-2xl);
        }

        .footer-description {
          color: var(--neutral-400);
          line-height: var(--leading-relaxed);
          margin: 0;
        }

        .footer-heading {
          font-family: var(--font-body);
          font-size: var(--text-base);
          font-weight: var(--weight-semibold);
          color: white;
          margin-bottom: var(--space-2);
        }

        .footer-links,
        .footer-contact {
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: var(--space-2);
        }

        .footer-links a,
        .footer-contact li {
          color: var(--neutral-400);
          text-decoration: none;
          transition: color var(--transition-fast);
          font-size: var(--text-sm);
        }

        .footer-links a:hover {
          color: var(--primary-300);
        }

        .footer-contact li {
          display: flex;
          align-items: center;
          gap: var(--space-2);
        }

        .footer-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: var(--space-8);
          border-top: 1px solid var(--neutral-800);
        }

        .footer-bottom p {
          color: var(--neutral-500);
          font-size: var(--text-sm);
          margin: 0;
        }

        .footer-legal {
          display: flex;
          gap: var(--space-6);
        }

        .footer-legal a {
          color: var(--neutral-500);
          font-size: var(--text-sm);
          text-decoration: none;
          transition: color var(--transition-fast);
        }

        .footer-legal a:hover {
          color: var(--primary-300);
        }

        @media (max-width: 768px) {
          .footer {
            padding: var(--space-12) 0 var(--space-6);
          }

          .footer-content {
            grid-template-columns: 1fr;
            gap: var(--space-8);
          }

          .footer-bottom {
            flex-direction: column;
            gap: var(--space-4);
            text-align: center;
          }

          .footer-legal {
            flex-direction: column;
            gap: var(--space-2);
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;